export const SidebarGroupLabel = ({ label }: { label: string }) => (
  <div className="flex h-8 items-center px-2">
    <p className="text-xs font-medium text-muted-foreground">{label}</p>
  </div>
);
